<p
  *ngIf="sentToEmail"
  class="text-secondary_Light_Text_Color xs:text-xs sm:text-sm poppinsRegular text-center"
>
  Enter the {{ otpLength }} digit code we sent to
  <span class="text-primary_Text_Color poppinsMedium break-all">
    {{ sentToEmail }}
  </span>
</p>

<div class="flex items-center justify-between mt-4">
  <p class="text-primary_Text_Color xs:text-xs sm:text-sm poppinsMedium">
    Verification code
  </p>
  <div *ngIf="timeLeft > 0" class="flex items-center gap-2">
    <img [src]="service.Images.CLOCK_ICON" width="15" alt="" />
    <span class="text-blue_Color xs:text-xs sm:text-sm poppinsSemiBold">
      00:<span *ngIf="timeLeft < 10">0</span>{{ timeLeft }}
    </span>
  </div>
  <p
    *ngIf="timeLeft <= 0"
    class="text-blue_Color xs:text-xs sm:text-sm poppinsSemiBold underline cursor-pointer"
    (click)="onResendOtp()"
  >
    Resend code
  </p>
</div>

<div
  [ngClass]="
    otpCode?.length === otpLength
      ? 'border-Active_Otp_Border'
      : 'border-card_Bg_Color'
  "
  class="otpVerifyBoxInput border rounded-lg mt-2 w-full flex items-center justify-center py-3"
>
  <ng-otp-input #otpInput [config]="config" (onInputChange)="onOtpChange($event)">
  </ng-otp-input>
</div>

<p
  *ngIf="errorMessage"
  class="text-medium_red_color xs:text-xxs sm:text-xs poppinsRegular mt-2 text-left"
>
  {{ errorMessage }}
</p>
